import { render, staticRenderFns } from "./MyBenefit.vue?vue&type=template&id=ff8c965a"
import script from "./MyBenefit.vue?vue&type=script&lang=js"
export * from "./MyBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports